import licensesModalStyle from '../../css/licenses-modal.module.css';

import { Row, Col } from 'react-bootstrap';

// Components
import Button from 'components/Button';
import TooltipDialog from 'components/TooltipDialog';
import ModalContainer from 'components/ModalContainer';
import DropdownWithItem from 'components/DropdownWithItem';
import RadioButton from 'components/RadioButton';
import Input from 'components/Input';
import DropdownWithCheckbox from 'components/DropdownWithCheckbox';

import AssignToSearchOrgInput from './AssignToSearchOrgInput';

import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import { uiActions } from "stores/slice/ui";
import AuthOrganizationService from "services/Auth.Organization.service";
import { dropdownLicenseTermList } from "../../useConst";

import { isNil, cloneDeep, size, orderBy } from "lodash";

const defaultAssignModalStatus = {
  selectedLicense: true,
  inactiveLicense: false,
  activeLicense: false,
};

const defaultSearchInputKey = {
  org: { name: "", total: 0, id: null },
  orgOptions: [],
};

const defaultInfo = {
  selectedTerm: {},
  inputQty: 0,
  // maxQty: 0,
  actived: [],
  inactived: [],
  termList: []
};

const AssignToModal = ({
  modalStatus,
  cancelModal,
  submitModal,
  dataList
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { pageContext } = useSelector((store) => store);

  const [assignToMode, setAssignToMode] = useState({ ...defaultAssignModalStatus });
  const [searchInputKey, setSearchInputKey] = useState(cloneDeep(defaultSearchInputKey));
  const [info, setInfo] = useState(cloneDeep(defaultInfo));

  const changeAssignToMode = useCallback(type => {
    const tmpAssignToMode = { ...assignToMode };
    Object.keys(tmpAssignToMode).forEach(key => tmpAssignToMode[key] = false);
    tmpAssignToMode[type] = true;
    setAssignToMode(tmpAssignToMode);
    setSearchInputKey(defaultSearchInputKey);
  }, []);

  const checkLic = (target) => {
    const copy = cloneDeep(info.actived);
    for (let item of copy) {
      if (item.title === target.title) {
        item.checked = !item.checked;
        break;
      }
    }
    setInfo({ ...info, actived: copy });
  };

  const changeTerm = (target) => {
    const copy = dropdownLicenseTermList();
    for (let item of copy) {
      if (target.days === item.days) {
        item.isActive = true;
        break;
      }
    }
    const inactived = getTargetLicList('inactived', target);
    setInfo({ ...info, selectedTerm: target, termList: copy, inactived, inputQty: 0 });
  };

  const getTargetLicList = (type, term) => {
    let result = [];
    if (type === 'actived') {
      for (const item of dataList) {
        if (!item.isChecked || item.deviceUid !== '') {
          continue;
        }
        if (item.startDateUnix !== '') {
          result.push({
            title: item.licenseKey,
            suffix: item.remainDayUnitLabelFull,
            checked: false
          });
        }
      }
    } else {
      for (const item of dataList) {
        if (!item.isChecked || item.deviceUid !== '') {
          continue;
        }
        if (item.startDateUnix === '' && item.termDays === term.days) {
          result.push({
            title: item.licenseKey,
            suffix: item.remainDayUnitLabelFull,
            checked: false
          });
        }
      }
    }
    return result;
  };

  const genLicList = () => {
    const termList = dropdownLicenseTermList();
    termList[0].isActive = true;
    const actived = getTargetLicList('actived');
    const inactived = getTargetLicList('inactived', termList[0]);
    setInfo({ ...info, actived, inactived, termList, selectedTerm: termList[0] });
  };

  const getResultList = () => {
    const list = [];
    if (assignToMode.selectedLicense) {
      for (const item of dataList) {
        if (item.isChecked)
          list.push(item.licenseKey);
      }
    } else if (assignToMode.inactiveLicense) {
      let count = 0;
      const targetCount = parseInt(info.inputQty);
      for (const item of info.inactived) {
        list.push(item.title);
        count++;
        if (count === targetCount) {
          break;
        }
      }
    } else {
      for (const item of info.actived) {
        if (item.checked)
          list.push(item.title);
      }
    }
    return list;
  };

  const submit = async () => {
    const data = {
      fromOrgId: pageContext.si.id,
      toOrgId: searchInputKey.org.id,
      licenseKeys: getResultList()
    };
    const res = await AuthOrganizationService.migrateBulkLicense(data);
    if (res?.data) {
      submitModal(res?.data);
    } else {
      submitModal([{ error: res.error, licenseKey: '' }]);
    }
    cancelModal();
  };

  useEffect(() => {
    setAssignToMode(defaultAssignModalStatus);
    setSearchInputKey(defaultSearchInputKey);
    setInfo(defaultInfo);
    genLicList();
  }, [modalStatus.assignTo.status, dataList]);

  return (
    <div className={licensesModalStyle['assign-to-modal']}>
      <ModalContainer
        modalWidthType="modal-500px"
        openModal={modalStatus.assignTo.status}
        closeModal={() => cancelModal()}
      >
        <div className="header">
          <div className="title">{t('0e62ec423e')}</div>
        </div>
        <div className="body">

          {/* Assign selected license keys */}
          <div>
            <div className="modal-form-title d-inline-flex">
              <RadioButton
                id="selectedLicense"
                name="selectedLicense"
                label={t('9cfdd1328d')}
                checked={assignToMode.selectedLicense}
                labelClassName="form-title"
                onChange={() => changeAssignToMode('selectedLicense')}
              />
              <TooltipDialog
                className="ms-2"
                placement="right"
                title={t('0c6fd07973')}
              ></TooltipDialog>
            </div>
          </div>

          {/* Assign selected license keys content */}
          <div className={
            `mb-1 ${licensesModalStyle['sub-content-container']} ${assignToMode.selectedLicense ? 'd-block' : 'd-none'}`
          }>
            <AssignToSearchOrgInput {...{ searchInputKey, setSearchInputKey, styleClass: 'selected-license-key-content' }} />
          </div>

          {/* Inactive license keys */}
          <div className='mt-3'>
            <div className="modal-form-title d-inline-flex">
              <RadioButton
                id="inactiveLicense"
                name="inactiveLicense"
                label={t('e1e6a3589d')}
                checked={assignToMode.inactiveLicense}
                labelClassName="form-title"
                onChange={() => changeAssignToMode('inactiveLicense')}
              />
              <TooltipDialog
                className="ms-2"
                placement="right"
                title={t('2637cf33d0')}
              ></TooltipDialog>
            </div>
          </div>

          {/* Inactive license keys content */}
          <div className={
            `mb-1 ${licensesModalStyle['sub-content-container']} ${!!assignToMode.inactiveLicense ? 'd-block' : 'd-none'}`
          }>
            <AssignToSearchOrgInput {...{ searchInputKey, setSearchInputKey, styleClass: 'inactive-license-key-content' }} />

            <div className="mt-3">
              <span className="modal-form-title">{t('8fccc52ef8')}</span>
              <span className="ms-1">
                <TooltipDialog
                  className="ms-2"
                  placement="right"
                  title={t('de8c84342e')}
                ></TooltipDialog>
              </span>
            </div>

            <Row className='mt-3'>
              <Col>
                <div className="modal-form-title">{t('9ec073dd2e')}</div>
                <DropdownWithItem
                  id="license-term-dropdown"
                  type="normal"
                  selectedItem={info?.selectedTerm || {}}
                  itemList={info?.termList || []}
                  onClick={(item) => { changeTerm(item); }}
                />
              </Col>
              <Col>
                <div className="modal-form-title">{t('b2a8f442fd')}</div>
                <Input
                  type="number"
                  value={info?.inputQty || 0}
                  min={0}
                  max={info?.inactived?.length || 0}
                  isInvalid={assignToMode.inactiveLicense && parseInt(info?.inputQty) === 0}
                  onChange={(e) => {
                    setInfo({ ...info, inputQty: e.target.value });
                  }}
                />
                <div>{`${info?.inactived?.length || 0} ${t('0399fb4c32')}`} </div>
              </Col>
            </Row>
          </div>

          {/* Active license keys */}
          <div className='mt-3'>
            <div className="modal-form-title d-inline-flex">
              <RadioButton
                id="activeLicense"
                name="activeLicense"
                label={t('880e1db411')}
                checked={assignToMode.activeLicense}
                labelClassName="form-title"
                onChange={() => changeAssignToMode('activeLicense')}
              />
              <TooltipDialog
                className="ms-2"
                placement="right"
                title={t('2a0bf8048a')}
              ></TooltipDialog>
            </div>
          </div>

          {/* Active license keys content */}
          <div className={
            `mb-1 ${licensesModalStyle['sub-content-container']} ${assignToMode.activeLicense ? 'd-block' : 'd-none'}`
          }>
            <Row>
              <Col>
                <AssignToSearchOrgInput {...{ searchInputKey, setSearchInputKey, styleClass: 'active-license-key-content' }} />
              </Col>

              <Col>
                <div className="modal-form-title required">{t('8ae3730ee1')}</div>
                <DropdownWithCheckbox
                  id="license-key-dropdown"
                  type="checkbox"
                  itemList={info?.actived || []}
                  onChange={item => { checkLic(item); }}
                />
              </Col>
            </Row>
          </div>

        </div>

        <div className={`footer ${licensesModalStyle['footer']}`}>
          <Button
            label={t('ea4788705e')}
            className="btn-cancel"
            disabled={false}
            onClick={() => cancelModal()}
          />
          <Button
            label={t('14f4e2f512')}
            className="btn-submit"
            disabled={false}
            onClick={() => { submit(); }}
          />
        </div>
      </ModalContainer>
    </div>
  );
};

export default AssignToModal;